<script setup lang="ts">
import {provide} from 'vue';
import {Dialog} from './dialog';
import {phraseContextKey} from './keys';


const props = defineProps<{
  dialog: Dialog
}>();

provide(phraseContextKey, props.dialog.phraseContext);

</script>

<template>
  <Suspense>
    <component
      :is="dialog.component"
      v-bind="dialog.props"
    />
  </Suspense>
</template>